<div #imageRef class="image-zoom-container">
  @if (lensVisible()) {
    <div #lens tabindex="-1" class="ui-magnifier-overlay"></div>
  }

  @defer (when imageOverlayPositionStrategy()) {
    <img
      #mainImage
      uiOverlay
      [overlayDisabled]="isMobile()"
      [positionStrategy]="imageOverlayPositionStrategy()"
      [positionStrategyMobile]="imageOverlayPositionStrategy()"
      [hasBackdrop]="false"
      [content]="overlayTemplate"
      (mousemove)="setPositions($event)"
      (mouseenter)="showZoom()"
      (mouseleave)="hideZoom()"
      width="500"
      height="500"
      priority
      [ngSrc]="src()"
      [alt]="alt()">
  }
</div>

<ng-template #overlayTemplate>
  <div #zoomImage [style.background-image]="'url(' + zoomImageSrc() + ')'" class="image-gallery-zoomed-image-container"></div>
</ng-template>
